import { Schema } from '../suggested-products'
import React from 'react'
import Image from '../imgix-img'
import { getValue } from '../../utils/product-schema'
import Button from '../../atoms/button'
import { FsCore } from '../../types/fs-core'

const CategoryPreview = ({
  products,
  schema,
  title,
  description,
  resultsPage,
}: {
  products: FsCore.ESHit[]
  schema: Schema
  title: string
  description: string
  resultsPage: string
}) => {
  return (
    <div className='CategoryPreview'>
      <h3 className='CategoryPreview__title'>{title}</h3>
      <div className='CategoryPreview__description'>{description}</div>
      <div className='CategoryPreview__products'>
        {products.map((product, key) => {
          return (
            <div key={key} className='CategoryPreview__products__product'>
              <Image
                src={getValue(schema.image, product)}
                width={300}
                alt='provider logo'
                critical={false}
              />
              <div className='CategoryPreview__products__product__title'>
                {getValue(schema.title, product)}
              </div>
              <div className='CategoryPreview__products__product__usp'>
                {getValue(schema.badge, product)}
              </div>
              <div className='CategoryPreview__products__product__cta'>
                <a
                  href={getValue(schema.primaryCta.href, product)}
                  className='CategoryPreview__products__product__cta--link'
                >
                  {getValue(schema.primaryCta.text, product)}
                </a>
                <Button
                  variant='icon'
                  size='sm'
                  href={getValue(schema.primaryCta.href, product)}
                  position={key}
                />
              </div>
            </div>
          )
        })}
      </div>
      <div className='CategoryPreview__categoryCTA'>
        <Button variant='secondary' size='md' href={resultsPage}>
          View more
        </Button>
        <a
          className='CategoryPreview__categoryCTA__complianceLink'
          href='/how-we-choose-your-business-products'
        >
          Click here to see why these are our top picks
        </a>
      </div>
    </div>
  )
}

export default CategoryPreview
